import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7074/DocuSign";
	}
	approveEnvelope(e, t) {
		let r = this.baseUrl + "/ApproveEnvelope", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processApproveEnvelope(e)));
	}
	processApproveEnvelope(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
	getDocuSignAuthorizationUrl(e, t) {
		let r = this.baseUrl + "/GetDocuSignAuthorizationUrl";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'returnPage' must be defined and cannot be null.");
		r += "returnPage=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetDocuSignAuthorizationUrl(e)));
	}
	processGetDocuSignAuthorizationUrl(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? g("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
	manualUpdateEnvelope(e, t) {
		let r = this.baseUrl + "/ManualUpdateEnvelope", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processManualUpdateEnvelope(e)));
	}
	processManualUpdateEnvelope(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? g("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
	processWebHook(e) {
		let t = this.baseUrl + "/ProcessWebHook", r = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processProcessWebHook(e)));
	}
	processProcessWebHook(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
	resendEnvelope(e, t) {
		let r = this.baseUrl + "/ResendEnvelope", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processResendEnvelope(e)));
	}
	processResendEnvelope(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
	storeAccessCode(e, t) {
		let r = this.baseUrl + "/StoreAccessCode";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
		r += "code=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "POST",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStoreAccessCode(e)));
	}
	processStoreAccessCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : g("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Success = "Success", e.InvalidAccount = "InvalidAccount", e.Error = "Error", e;
}({}), h = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isDocuSignApiException = !0;
	static isDocuSignApiException(e) {
		return e.isDocuSignApiException === !0;
	}
};
function g(e, t, n, r, i) {
	throw i ?? new h(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var _ = "docusign";
function v(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var y = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), v(r);
}, b = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[_] || `${e}/${_}`;
}, x = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = b(i), u = c, d = y(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = y(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, S = a({}), C = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = x(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(S.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, w = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(S), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.approveEnvelope(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		approveEnvelope: d,
		approveEnvelopePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, T = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(S), s;
	n[0] === e ? s = n[1] : (s = ["getDocuSignAuthorizationUrl", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getDocuSignAuthorizationUrl(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, E = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getDocuSignAuthorizationUrl", ...n] });
	}, e[0] = t, e[1] = n), n;
}, D = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(S), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.manualUpdateEnvelope(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		manualUpdateEnvelope: d,
		manualUpdateEnvelopePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, O = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(S), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.resendEnvelope(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		resendEnvelope: d,
		resendEnvelopePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, k = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(S), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.storeAccessCode(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		storeAccessCode: d,
		storeAccessCodePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { S as DocuSignApiContext, h as DocuSignApiException, C as DocuSignApiProvider, p as DocuSignClient, _ as DocuSignRoute, m as StoreAccessCodeResponseResult, w as useApproveEnvelope, x as useDocuSignClientContext, T as useGetDocuSignAuthorizationUrl, E as useInvalidateUseGetDocuSignAuthorizationUrl, D as useManualUpdateEnvelope, O as useResendEnvelope, k as useStoreAccessCode };
